import { useState } from "react";

import { useNavigate } from "common/router/hooks";
import Navigate, { NavigateProps } from "common/router/Navigate";

import Page from "client/common/components/layouts/Page";
import Modal from "client/common/components/deprecated-modals/Modal";
import LoadingContainer from "client/common/components/loading/LoadingContainer";
import ModalLayout from "client/common/components/deprecated-modals/ModalLayout";
import StreamlinedHeader from "client/common/components/header/StreamlinedHeader";
import { useBreakpoints } from "client/common/hooks";
import { urls } from "client/routes";

import OnboardingSubscriptionsHelp from "./OnboardingSubscriptionsHelp";

import styles from "../styles/OnboardingSubscriptionsStepPage.module.less";

type OnboardingSubscriptionsStepPageHeaderProps = {
  onPrevious?: () => void;
};

const OnboardingSubscriptionsStepPageHeader = ({
  onPrevious,
}: OnboardingSubscriptionsStepPageHeaderProps) => {
  const [isHelpOpen, setIsHelpOpen] = useState(false);
  const navigate = useNavigate();
  const { isTabletPortraitAndSmaller } = useBreakpoints();

  return (
    <>
      <StreamlinedHeader
        onPrevious={onPrevious || (() => navigate(urls.onboarding.subscriptions.start()))}
        onHelp={isTabletPortraitAndSmaller ? () => setIsHelpOpen(true) : undefined}
      />
      <Modal onClose={() => setIsHelpOpen(false)} visible={isHelpOpen}>
        <ModalLayout>
          <ModalLayout.Header onClose={() => setIsHelpOpen(false)} />
          <ModalLayout.Content>
            <div className={styles.helpContent}>
              <OnboardingSubscriptionsHelp />
            </div>
          </ModalLayout.Content>
        </ModalLayout>
      </Modal>
    </>
  );
};

type OnboardingSubscriptionsStepPageProps = {
  onPrevious?: () => void;
  children?: React.ReactNode;
};

const OnboardingSubscriptionsStepPage = ({
  children,
  onPrevious,
}: OnboardingSubscriptionsStepPageProps) => {
  return (
    <Page Header={<OnboardingSubscriptionsStepPageHeader onPrevious={onPrevious} />} Footer={null}>
      <div className={styles.page}>
        <div className={styles.main}>{children}</div>
        <div className={styles.background} />
        <div className={styles.sider}>
          <div className={styles.siderContent}>
            <OnboardingSubscriptionsHelp />
          </div>
        </div>
      </div>
    </Page>
  );
};

const LoadingOnboardingSubscriptionsStepPage = () => {
  return (
    <OnboardingSubscriptionsStepPage>
      <LoadingContainer />
    </OnboardingSubscriptionsStepPage>
  );
};

type RedirectInvalidOnboardingSubscriptionsStepPageProps = NavigateProps;

const RedirectInvalidOnboardingSubscriptionsStepPage = (
  props: RedirectInvalidOnboardingSubscriptionsStepPageProps,
) => {
  return (
    <OnboardingSubscriptionsStepPage>
      <Navigate {...props} />
    </OnboardingSubscriptionsStepPage>
  );
};

export default Object.assign(OnboardingSubscriptionsStepPage, {
  Loading: LoadingOnboardingSubscriptionsStepPage,
  RedirectInvalid: RedirectInvalidOnboardingSubscriptionsStepPage,
});
